import React, { useState, useContext } from 'react';
import './UsersList.css';
import { AuthContext } from '../../context/AuthContext';

// Importando componentes do SuperAdmin
import SuperAdminUsers from '../superAdmin/components/SuperAdminUsers';
import SuperAdminCompanies from '../superAdmin/components/SuperAdminCompanies';
import SuperAdminExclusions from '../superAdmin/components/SuperAdminExclusions';

export default function UsersList() {
  const { user: currentUser } = useContext(AuthContext);

  // Estado para tab ativa
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="users-page">
      <div className="container">
        <div className="users-header">
          <div className="header-content">
            <h1 className="page-title">Gerenciar Usuários</h1>
            <p className="page-subtitle">
              Visualize e gerencie todos os usuários da plataforma
            </p>
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs-container" style={{ marginBottom: 'var(--space-6)' }}>
          <button
            className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
            onClick={() => setActiveTab('users')}
          >
            Usuários
          </button>
          <button
            className={`tab-button ${activeTab === 'companies' ? 'active' : ''}`}
            onClick={() => setActiveTab('companies')}
          >
            Empresas
          </button>
          {(currentUser?.role === 'SUPER_ADMIN' || currentUser?.role === 'ADMIN_EAD') && (
            <button
              className={`tab-button ${activeTab === 'exclusions' ? 'active' : ''}`}
              onClick={() => setActiveTab('exclusions')}
            >
              Lixeira
            </button>
          )}
        </div>

        {/* Conteúdo das tabs */}
        {activeTab === 'users' && (
          <SuperAdminUsers currentUser={currentUser} />
        )}

        {activeTab === 'companies' && (
          <SuperAdminCompanies currentUser={currentUser} />
        )}

        {(currentUser?.role === 'SUPER_ADMIN' || currentUser?.role === 'ADMIN_EAD') && activeTab === 'exclusions' && (
          <SuperAdminExclusions />
        )}
      </div>
    </div>
  );
}